import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "sw_cookie_consent";

export default function CookieConsent() {
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try { if (!localStorage.getItem(KEY)) setShow(true); } catch { setShow(true); }
  }, []);

  const accept = () => {
    try { localStorage.setItem(KEY, "accepted"); } catch { /* ignore */ }
    setShow(false);
  };

  // Only show on the public landing page — never on the app, embeds or video screens.
  if (location.pathname !== "/") return null;
  if (!show) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6 sm:pb-6"
    >
      <div className="mx-auto max-w-3xl rounded-2xl border border-amber-500/25 bg-[#111827]/95 backdrop-blur px-5 py-4 shadow-2xl flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
          <p className="text-sm leading-relaxed text-gray-300">
            We use cookies to keep you signed in and to understand how our content is viewed. See our{" "}
            <Link to="/privacy" className="text-amber-400 hover:underline">Privacy Policy</Link>.
          </p>
        </div>
        <div className="flex shrink-0 items-center gap-2 self-end sm:self-auto">
          <Link
            to="/privacy"
            data-testid="cookie-learn-more"
            className="rounded-lg px-3 py-2 text-sm text-gray-400 hover:text-white transition-colors"
          >
            Learn more
          </Link>
          <button
            onClick={accept}
            data-testid="cookie-accept"
            className="rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-black transition-colors hover:bg-amber-400"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
